import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'src/domains/common/components/button/button';
import { InputField } from 'src/components/LicenseConfig/shared/InputField/InputField';
import { ActivityTimeframeState } from 'src/components/ComplianceConfiguration/ActivityTimeframe/ActivityTimeframe.state';
import {
    ActivityTimeframeActions,
    ActivityTimeframeFormFields,
    ActivityTimeframeFormLabel,
    ActivityTimeframeFormRow,
    ActivityTimeframeFormValue,
    ActivityTimeframeSection,
    ActivityTimeframeSectionTitle,
    ActivityTimeframeUnitSuffix,
} from 'src/components/ComplianceConfiguration/ActivityTimeframe/ActivityTimeframe.style';

interface ActivityTimeframeFormPropsType {
    state: ActivityTimeframeState;
}

export const ActivityTimeframeForm = observer(({ state }: ActivityTimeframeFormPropsType): JSX.Element => {
    const hasErrors = state.activityMinutes.result.value.type === 'error';

    const handleSubmit = (event: React.FormEvent): void => {
        event.preventDefault();
        void state.updateConfig();
    };

    return (
        <ActivityTimeframeSection data-test='compliance-configuration-activity-timeframe-form'>
            <ActivityTimeframeSectionTitle>Activity detection window</ActivityTimeframeSectionTitle>
            <form onSubmit={handleSubmit}>
                <ActivityTimeframeFormFields>
                    <ActivityTimeframeFormRow>
                        <ActivityTimeframeFormLabel htmlFor='activity-timeframe-minutes'>
                            Count user as active when they perform one action every
                        </ActivityTimeframeFormLabel>
                        <ActivityTimeframeFormValue>
                            <InputField
                                formInputState={state.activityMinutes}
                                disabled={state.isSaving}
                                originalValue={state.originalMinutesValue}
                                name='activity-timeframe-minutes'
                                placeholder='1'
                                allowedPattern={/^\d*$/}
                                inputMode='numeric'
                            />
                            <ActivityTimeframeUnitSuffix>minutes</ActivityTimeframeUnitSuffix>
                        </ActivityTimeframeFormValue>
                    </ActivityTimeframeFormRow>
                </ActivityTimeframeFormFields>
                <ActivityTimeframeActions>
                    <Button
                        dataTest='compliance-configuration-activity-timeframe-submit'
                        disabled={state.isSaving || hasErrors}
                        isLoading={state.isSaving}
                        type='submit'
                    >
                        Save configuration
                    </Button>
                </ActivityTimeframeActions>
            </form>
        </ActivityTimeframeSection>
    );
});
